import { Component, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const OLD_HOST = 'txpchat.com';
const NEW_HOST = 'omnilife.io';
const OLD_SUBDOMAIN = 'web';
const NEW_SUBDOMAIN = 'messages';

class Redirect extends Component<Props> {
  render() {
    if (typeof window !== 'undefined' && window.location && window.location.hostname.toLowerCase().includes(OLD_HOST)) {
      const domainRegExp = new RegExp(OLD_HOST, 'i');
      // replace the domain
      let newURL = window.location.href.replace(domainRegExp, NEW_HOST);

      // replace the subdomain
      const subdomainRegExp = new RegExp(OLD_SUBDOMAIN, 'i');
      newURL = newURL.replace(subdomainRegExp, NEW_SUBDOMAIN);

      window.location.href = newURL;
      return null;
    }

    return <div>{this.props.children}</div>;
  }
}

export default Redirect;
